/**
 * A validation rule that ensures the input’s value is postal code.
 */
const postal = function (node) {
  const regex = /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/;
  return regex.test(node.value);
}

// override default rule behaviors for your custom rule
postal.blocking = false
postal.skipEmpty = false
postal.debounce = 20 // milliseconds
postal.force = true

export default postal
